export default {
  data() {
    const config = this.$config.public
    return {
      freePlan: {
        storage_quota: parseInt(config.baserowFreeTierQuotaStorage || 0),
        rows_quota: parseInt(config.baserowFreeTierQuotaRows || 0),
        page_views_quota: parseInt(config.baserowFreeTierQuotaPageViews || 0),
        application_users_quota: parseInt(
          config.baserowFreeTierQuotaApplicationUsers || 0
        ),
      },
    }
  },
  methods: {
    storageUsageInGB(workspace, decimalPlaces = 1) {
      if (!workspace) {
        return 0
      }

      const inMegaBytes = workspace.storage_usage || 0
      const gigaBytes = inMegaBytes / 1024
      return parseFloat(gigaBytes).toFixed(decimalPlaces)
    },
    overLimits(rowCount, storageUsage, rowsQuota, storageQuota) {
      const quotaInMegaBytes = storageQuota * 1024
      return storageUsage > quotaInMegaBytes || rowCount > rowsQuota
    },
  },
}
